export default __webpack_public_path__ + "static/media/BestMeter.05fee987.svg";